import { computed, ref } from 'vue';
import { useRoute } from 'vue-router';
import { ReverseEngineeringApi } from '@/domains/material/apis/re-api';
import { injectService } from '@patsnap/tahiti-core/ioc/inject';
import { Toast } from 'patsnap-biz';
import { setupI18n } from '@eureka/shared/locales/i18n';

export const useShareConversation = () => {
  const route = useRoute();
  const { t } = setupI18n();
  const apiService = injectService<ReverseEngineeringApi>(ReverseEngineeringApi);
  const isSharing = ref(false);
  const isModalVisible = ref(false);

  const generateShareLink = () => {
    const currentUrl = window.location.href;
    const shareUrl = currentUrl.replace('#/reverse-engineering/', '#/reverse-engineering/shared/');
    return shareUrl;
  };

  const shareConversation = async (setLinkCallback?: (l: string) => void) => {
    try {
      const conversationId = route.params.conversation_id as string;
      isSharing.value = true;
      await apiService.shareConversation(conversationId);
      isSharing.value = false;
      isModalVisible.value = true;

      if (setLinkCallback) {
        setLinkCallback(generateShareLink());
      }
    } catch {
      isSharing.value = false;
      Toast({
        type: 'error',
        message: t('ReverseEngineering.share.error'),
        duration: 5000,
      });
    }
  };

  const isViewingShared = computed(() => {
    return route.name === 'ReverseEngineeringSharedConversation'
  })

  return {
    isSharing,
    isModalVisible,
    isViewingShared,
    shareConversation,
  };
};
